// extracted by mini-css-extract-plugin
export var cardLayout = "_8u-1";
export var paginationContainer = "_8u-0";